import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

interface LegalPageProps {
  title: string;
  content: string;
}

export default function LegalPage({ title, content }: LegalPageProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="mx-auto max-w-3xl px-6 py-12 sm:py-16">
        <Button
          variant="ghost"
          size="sm"
          onClick={handleBack}
          className="mb-8 -ml-2 text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>

        <article
          className="prose prose-invert max-w-none
            prose-headings:font-black prose-headings:tracking-tight
            prose-h1:text-3xl prose-h1:sm:text-4xl prose-h1:mb-2
            prose-h2:text-xl prose-h2:mt-10 prose-h2:mb-4 prose-h2:text-foreground
            prose-h3:text-lg prose-h3:text-foreground
            prose-p:text-muted-foreground prose-p:leading-relaxed
            prose-li:text-muted-foreground
            prose-strong:text-foreground prose-strong:font-semibold
            prose-em:text-muted-foreground
            prose-a:text-primary prose-a:no-underline hover:prose-a:underline
            prose-hr:border-border"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
}
